import i18next, { TFunction } from 'i18next'
import { languageSkillOptions } from '../components/MySkills/PersonLanguages/languageSkillOptions'

export function localizedLanguageSkills(t: TFunction) {
  return languageSkillOptions.map((lang) => {
    return {
      key: lang.key,
      text: t(`LanguageOptions.${lang.key.replace(':', '')}`) || lang.text,
      value: lang.value,
    }
  })
}

export function localizedLanguageNames(
  languages: Array<{
    key: string
    text: string
    value: string
  }>,
  t: TFunction,
) {
  return languages.map((lang) => {
    return {
      key: lang.key,
      text: localizedLanguageName(lang.text, t),
      value: lang.value,
    }
  })
}

export function localizedLanguageName(name: string, t: TFunction) {
  return (
    t(`LanguageNames.${name?.trim()}`, {
      defaultValue: name,
    }) || name
  )
}

/**
 * Localizes a language name for CV export using a specific language.
 * Unlike localizedLanguageName, this function takes an explicit language parameter
 * instead of using the current UI language from the translation context.
 *
 * @param name - The language name to localize (e.g., "englanti", "suomi")
 * @param lang - The target language for localization ('fi' | 'en')
 * @returns The localized language name
 */
export function localizedLanguageNameForExport(name: string, lang: 'fi' | 'en'): string {
  const fixedT = i18next.getFixedT(lang)
  return fixedT(`LanguageNames.${name?.trim()}`, { defaultValue: name }) || name
}

/**
 * Localizes a language skill level for CV export using a specific language.
 * Converts skill levels like "A1: perustason kielenkäyttäjä" to "A1: Beginner".
 *
 * @param level - The skill level to localize (e.g., "A1: perustason kielenkäyttäjä")
 * @param lang - The target language for localization ('fi' | 'en')
 * @returns The localized skill level
 */
export function localizedLanguageLevelForExport(level: string, lang: 'fi' | 'en'): string {
  const fixedT = i18next.getFixedT(lang)
  const key = level?.replace(':', '').trim()
  return fixedT(`LanguageOptions.${key}`, { defaultValue: level }) || level
}
